"use client";

import dynamic from "next/dynamic";

const EuropaGlobe = dynamic(
  () => import("@/components/three/EuropaGlobe").then((m) => m.EuropaGlobe),
  {
    ssr: false,
    loading: () => <GlobeSkeleton />,
  },
);

function GlobeSkeleton() {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="relative w-[78%] aspect-square">
        <div className="absolute inset-0 rounded-full border border-line-200" />
        <div className="absolute inset-[12%] rounded-full border border-line-200/60" />
        <div className="absolute inset-[24%] rounded-full border border-line-200/40 animate-pulse" />
      </div>
    </div>
  );
}

/**
 * Client wrapper that lazy-loads the React Three Fiber globe. Used inside
 * server components — Canvas needs DOM, so `ssr: false`.
 */
export function PartnersMap() {
  return (
    <div className="relative aspect-square w-full">
      <EuropaGlobe />
    </div>
  );
}
